import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';

import { getDeliveryTypeIcons } from './DeliveryTypeSelector.utils';
import {
  DeliveryTypeSelectorProps,
  useDeliveryTypeSelector,
} from './useDeliveryTypeSelector';

export const DeliveryTypeSelector = ({
  allowCustomDeliveryType,
  placeholderText = ContentId.AllDeliveryOptions,
  valueOptionsContent,
  ...rest
}: DeliveryTypeSelectorProps) => {
  const { moderatedOptionsContent } = useDeliveryTypeSelector({
    allowCustomDeliveryType,
    valueOptionsContent,
  });

  return (
    <PosEnumSelect
      style={{ width: '100%' }}
      {...rest}
      placeholderText={placeholderText}
      valueOptionsContent={moderatedOptionsContent}
      valueOptionsIcon={getDeliveryTypeIcons()}
    />
  );
};
